import { render, staticRenderFns } from "./AdminDashboardIndex.vue?vue&type=template&id=e1b69cce&"
import script from "./AdminDashboardIndex.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports